import React from "react";
import Slider from "react-slick";
import "./trending.css";
import { Link } from "react-router-dom";
import { formatDate, stripHtml } from "../utility/utility";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BlogAPIUrl = process.env.REACT_APP_BLOG_API_URL;

const TrendingCarousel = ({ blogPosts = [],detail = false }) => {

  const settings = {
    dots: false,
    infinite: blogPosts.length > 3,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    vertical: detail,          // vertical slider
    verticalSwiping: detail,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <div className="trending-container-main">

      <div className="trending-container" style={{ padding: detail ? "0" : "0 20px" }}>
        <h1 className="trending-title">Trending</h1>

        <Slider {...settings}>

          {blogPosts?.map((post) => (

            <div key={post.id} className="trending-card">

              <div className="trending-card-content">

                <Link to={`/blogs/${post?.slug}`} state={post?.id}>

                  <img
                    src={
                      post.image
                        ? `${BlogAPIUrl}uploads/files/${post.image}`
                        : "/placeholder.jpg"
                    }
                    alt={post.title}
                    className="blog-image-popular"
                  />

                </Link>

                <div className="trending-info">

                  <div className="trending-meta">
                    <div className="tbc-blog-author-date">
                      By {post?.author?.name} | {formatDate(post?.created_at)}
                    </div>
                  </div>

                  <h2
                    className="trending-blog-title"
                  // dangerouslySetInnerHTML={{
                  //   __html: post.heading?.replace(/<\/?p>/g, "")
                  // }}
                  >
                    {stripHtml(post.heading)}
                  </h2>

                  <p
                    className="trending-excerpt"
                  // dangerouslySetInnerHTML={{
                  //   __html: post.description?.replace(/<\/?p>/g, "")
                  // }}
                  > {stripHtml(post.description)}</p>

                  <div className="trending-footer">
                    <Link to={`/blogs/${post?.slug}`}
                      state={post?.id}
                      className="trending-read-more"
                    >
                      Read blog →
                    </Link>
                  </div>

                </div>

              </div>

            </div>

          ))}

        </Slider>

      </div>

    </div>
  );
};

export default TrendingCarousel;